const WaitRipple = ( props:{ text?:string } ) => (
    <div className="lds-ripple">
        {props.text && <h2>{props.text}</h2> }
        
        <div></div><div></div></div> );

export default WaitRipple;